import 'driver.js/dist/driver.css';
import {driver} from 'driver.js';

document.addEventListener('turbolinks:load', () => {
    const driverObj = driver({
        popoverClass: 'driverjs-theme',
        animate: false,   // Animate while changing highlighted elements
        opacity: 0.75,   // Background opacity (0 means only popovers and without overlay)
        padding: 10,     // Distance of element from around the edges
        allowClose: true, // Allow the tour to be closed at any time
        showProgress: true,
        showButtons: ['next', 'previous'],
        steps: [
            {
                element: '#feature_1',
                popover: {
                    title: 'Import the Library',
                    description: 'It works the same in vanilla JavaScript as well as frameworks.',
                    side: "bottom",
                    align: 'start'
                }
            },
            {
                element: '#feature_2',
                popover: {
                    title: 'Importing CSS',
                    description: 'Import the CSS which gives you the default styling for popover and overlay.',
                    side: "bottom",
                    align: 'start'
                }
            },
            {
                element: '#feature_3',
                popover: {
                    title: 'Create Driver',
                    description: 'Simply call the driver function to create a driver.js instance',
                    side: "left",
                    align: 'start'
                }
            },
            {
                element: '#feature_4',
                popover: {
                    title: 'Start Tour',
                    description: 'Call the drive method to start the tour and your tour will be started.',
                    side: "top",
                    align: 'start'
                }
            },
            {
                element: '#feature_5',
                popover: {
                    title: 'More Configuration',
                    description: 'Look at this page for all the configuration options you can pass.',
                    side: "right",
                    align: 'start'
                }
            },
            {
                popover: {
                    title: 'Happy Coding',
                    description: 'And that is all, go ahead and start adding tours to your applications.'
                }
            }
        ]
    });


    // Start the tour when the user clicks a "Start Tour" button
    const tourButton = document.getElementById('start-tour');
    if (tourButton) {
        tourButton.addEventListener('click', () => driverObj.drive());
    }
});